import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=360f995f&scoped=true&"
import script from "./registered.vue?vue&type=script&lang=js&"
export * from "./registered.vue?vue&type=script&lang=js&"
import style0 from "./registered.vue?vue&type=style&index=0&id=360f995f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360f995f",
  null
  
)

export default component.exports